import React from 'react'
import Services from './Services/Services'
import Rbu from './Rbu/Rbu'
import Technology from './Technology/Technology'
import Experts from './Experts/Experts'
import About from './About/About'
import Hmclient from './Hmclient/Hmclient'
import Hmproject from './Hmproject/Hmproject'
import Hww from './Hww/Hww'
import Slider from './Slider/Slider'
import Choose from './Choose/Choose'
import Testimonial from './Testimonial/Testimonial'

function Home() {
  return (
    <>
      <Slider/>
      <Services/>
      <Hmproject/>
      <About/>
      <Hww />
      <Choose/>
      <Rbu />
      <Technology />
      <Hmclient />
      <Testimonial/>
      <Experts/>  
    </>
  )
}

export default Home

